/* ==========================================================================
   Auberlane — global.js
   Vanilla JS, no dependencies. Drives: overlay drawers (mobile nav, cart,
   predictive search), sticky header, mobile submenu toggles, accordions,
   variant picker, gallery/lightbox, sticky add-to-cart, quantity steppers,
   cart add/change via the Shopify AJAX API.
   2026-07-24: updateCartUI now emits a 'cart:updated' event and listens for
   'cart:refresh' so the cart-upsell snippet can stay in sync.
   ========================================================================== */
(function () {
  'use strict';

  var scrim = document.querySelector('[data-overlay-scrim]');
  var openDrawerEl = null;

  function lockScroll(lock) { document.body.style.overflow = lock ? 'hidden' : ''; }

  function openOverlay(el) {
    if (!el) return;
    if (openDrawerEl && openDrawerEl !== el) closeOverlay();
    el.classList.add('is-open');
    el.removeAttribute('hidden');
    if (scrim) { scrim.removeAttribute('hidden'); requestAnimationFrame(function () { scrim.classList.add('is-visible'); }); }
    openDrawerEl = el;
    lockScroll(true);
    var focusable = el.querySelector('input, button, a');
    if (focusable && el.dataset.autofocus === 'true') setTimeout(function(){ focusable.focus(); }, 280);
  }
  function closeOverlay() {
    if (openDrawerEl) { openDrawerEl.classList.remove('is-open'); }
    if (scrim) { scrim.classList.remove('is-visible'); setTimeout(function () { scrim.setAttribute('hidden', ''); }, 260); }
    var prev = openDrawerEl; openDrawerEl = null; lockScroll(false);
    setTimeout(function(){ if (prev && prev.hasAttribute('data-hide-when-closed')) prev.setAttribute('hidden',''); }, 280);
  }
  if (scrim) scrim.addEventListener('click', closeOverlay);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeOverlay(); closeLightbox(); closeModal(); } });

  // Generic open/close triggers
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-overlay-open]');
    if (openBtn) { e.preventDefault(); openOverlay(document.getElementById(openBtn.getAttribute('data-overlay-open'))); return; }
    var closeBtn = e.target.closest('[data-overlay-close]');
    if (closeBtn) { e.preventDefault(); closeOverlay(); return; }
  });

  /* ---------- Sticky header shadow ---------- */
  var header = document.querySelector('.header-wrap');
  if (header && header.classList.contains('is-sticky')) {
    var lastY = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 4);
      lastY = y;
    }, { passive: true });
  }

  /* ---------- Mobile submenu toggles ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.mobile-nav__toggle');
    if (!t) return;
    e.preventDefault();
    t.closest('.mobile-nav__item').classList.toggle('is-open');
  });

  /* ---------- Accordions (FAQ + PDP) ---------- */
  document.addEventListener('click', function (e) {
    var trig = e.target.closest('.accordion__trigger');
    if (!trig) return;
    var item = trig.closest('.accordion__item');
    var panel = item.querySelector('.accordion__panel');
    var open = item.classList.toggle('is-open');
    panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
  });

  /* ---------- Announcement rotator ---------- */
  document.querySelectorAll('[data-announcement-rotator]').forEach(function (rot) {
    var msgs = rot.querySelectorAll('.announcement__msg');
    if (msgs.length < 2) return;
    var i = 0, speed = parseInt(rot.dataset.speed || '5', 10) * 1000;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, speed);
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty button');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    var val = parseInt(input.value || '1', 10);
    val += btn.dataset.dir === 'up' ? 1 : -1;
    if (val < parseInt(input.min || '1', 10)) val = parseInt(input.min || '1', 10);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart: AJAX add + drawer ---------- */
  function fetchCart() { return fetch(window.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

  function updateCartUI(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.toggleAttribute('hidden', cart.item_count === 0);
    });
    var drawerBody = document.querySelector('[data-cart-lines]');
    if (drawerBody) renderCartLines(cart, drawerBody);
    var totalEl = document.querySelector('[data-cart-total]');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    var footEl = document.querySelector('[data-cart-foot]');
    if (footEl) footEl.toggleAttribute('hidden', cart.item_count === 0);
    var emptyEl = document.querySelector('[data-cart-empty]');
    if (emptyEl) emptyEl.toggleAttribute('hidden', cart.item_count !== 0);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  }

  function formatMoney(cents) {
    return (window.Shopify && window.Shopify.currency ? '' : '$') + (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/^/, '$');
  }

  function renderCartLines(cart, container) {
    if (!cart.items.length) { container.innerHTML = ''; return; }
    container.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[^.]+)$/, '_120x150$1') : '';
      var opts = it.options_with_values ? it.options_with_values.map(function (o) { return o.value; }).join(' · ') : '';
      return '<div class="cart-line" data-line-key="' + it.key + '">' +
        '<div class="cart-line__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div><div class="cart-line__title">' + it.product_title + '</div>' +
        (opts ? '<div class="cart-line__meta">' + opts + '</div>' : '') +
        '<div class="qty" style="margin-top:8px"><button data-line-dir="down" aria-label="Decrease">&minus;</button>' +
        '<input type="text" inputmode="numeric" value="' + it.quantity + '" data-line-qty readonly><button data-line-dir="up" aria-label="Increase">+</button></div>' +
        '</div><div style="text-align:right"><div class="cart-line__price">' + formatMoney(it.final_line_price) + '</div>' +
        '<button class="btn--link" style="font-size:.78rem;margin-top:8px;color:var(--muted)" data-line-remove>Remove</button></div></div>';
    }).join('');
  }

  function changeLine(key, qty) {
    return fetch(window.routes.cart_change_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(updateCartUI);
  }

  // delegated cart-line controls
  document.addEventListener('click', function (e) {
    var line = e.target.closest('.cart-line'); if (!line) return;
    var key = line.getAttribute('data-line-key');
    var input = line.querySelector('[data-line-qty]');
    if (e.target.closest('[data-line-remove]')) { changeLine(key, 0); return; }
    var dirBtn = e.target.closest('[data-line-dir]');
    if (dirBtn) {
      var q = parseInt(input.value, 10) + (dirBtn.getAttribute('data-line-dir') === 'up' ? 1 : -1);
      changeLine(key, Math.max(0, q));
    }
  });

  // Add-to-cart forms (PDP, quick-add)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }
    fetch(window.routes.cart_add_url + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        updateCartUI(cart);
        if (btn) { btn.innerHTML = 'Added ✓'; setTimeout(function () { btn.innerHTML = original; btn.disabled = false; }, 1200); }
        openOverlay(document.getElementById('CartDrawer'));
      })
      .catch(function () { if (btn) { btn.innerHTML = original; btn.disabled = false; } });
  });

  document.addEventListener('DOMContentLoaded', function () { fetchCart().then(updateCartUI).catch(function(){}); });
  document.addEventListener('cart:refresh', function () { fetchCart().then(updateCartUI).catch(function(){}); });

  /* ---------- Predictive search ---------- */
  var psInput = document.querySelector('[data-predictive-input]');
  var psPanel = document.querySelector('[data-predictive-panel]');
  if (psInput && psPanel) {
    var psTimer;
    psInput.addEventListener('input', function () {
      clearTimeout(psTimer);
      var q = psInput.value.trim();
      if (q.length < 2) { psPanel.innerHTML = ''; return; }
      psTimer = setTimeout(function () {
        var url = window.routes.predictive_search_url + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&section_id=predictive-search';
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var results = doc.querySelector('[data-predictive-results]');
          psPanel.innerHTML = results ? results.innerHTML : '<div style="padding:20px;color:var(--muted)">No matches.</div>';
        }).catch(function(){});
      }, 220);
    });
  }

  /* ---------- PDP: gallery + variants + sticky ATC + lightbox + modal ---------- */
  // Gallery thumbnails
  document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    var main = gal.querySelector('[data-gallery-main] img');
    gal.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        gal.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (main) { main.src = thumb.getAttribute('data-full'); }
      });
    });
    var mainWrap = gal.querySelector('[data-gallery-main]');
    if (mainWrap) mainWrap.addEventListener('click', function () { openLightbox(main.src); });
  });

  // Lightbox
  var lightbox = document.getElementById('Lightbox');
  function openLightbox(src) { if (!lightbox) return; lightbox.querySelector('img').src = src; lightbox.classList.add('is-open'); lockScroll(true); }
  function closeLightbox() { if (lightbox) { lightbox.classList.remove('is-open'); if (!openDrawerEl) lockScroll(false); } }
  if (lightbox) lightbox.addEventListener('click', function (e) { if (e.target === lightbox || e.target.closest('[data-lightbox-close]')) closeLightbox(); });

  // Size-guide modal (generic)
  function closeModal() { document.querySelectorAll('.modal.is-open').forEach(function (m) { m.classList.remove('is-open'); }); if (!openDrawerEl) lockScroll(false); }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-modal-open]');
    if (open) { e.preventDefault(); var m = document.getElementById(open.getAttribute('data-modal-open')); if (m) { m.classList.add('is-open'); lockScroll(true); } return; }
    var close = e.target.closest('[data-modal-close]');
    if (close) { closeModal(); return; }
    if (e.target.classList && e.target.classList.contains('modal')) closeModal();
  });

  // Variant picker
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var data = form.querySelector('[data-variants-json]');
    if (!data) return;
    var variants = JSON.parse(data.textContent || '[]');
    var idInput = form.querySelector('[name="id"]');
    var selected = {};
    form.querySelectorAll('[data-option-index]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var idx = pill.getAttribute('data-option-index');
        form.querySelectorAll('[data-option-index="' + idx + '"]').forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        selected[idx] = pill.getAttribute('data-option-value');
        resolveVariant();
      });
    });
    // seed defaults from pre-active pills
    form.querySelectorAll('.variant-pill.is-active').forEach(function (p) { selected[p.getAttribute('data-option-index')] = p.getAttribute('data-option-value'); });

    // Swap the gallery to a variant's featured image. Prefers clicking the
    // matching thumbnail (keeps thumb active-state in sync); falls back to
    // setting the main image src directly.
    function swapGalleryImage(src) {
      if (!src) return;
      var pdp = form.closest('.pdp');
      var gal = pdp ? pdp.querySelector('[data-gallery]') : document.querySelector('[data-gallery]');
      if (!gal) return;
      var path = src.split('?')[0];
      var matched = null;
      gal.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        if ((t.getAttribute('data-full') || '').split('?')[0] === path) matched = t;
      });
      if (matched) { matched.click(); return; }
      var main = gal.querySelector('[data-gallery-main] img');
      if (main) main.src = src;
    }

    function resolveVariant() {
      var match = variants.find(function (v) {
        return Object.keys(selected).every(function (k) { return v.options[parseInt(k, 10)] === selected[k]; });
      });
      var priceEl = form.querySelector('[data-price-current]');
      var atc = form.querySelector('[data-atc-btn]');
      if (match) {
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = formatMoney(match.price);
        if (atc) { atc.disabled = !match.available; atc.querySelector('[data-atc-label]').textContent = match.available ? (atc.getAttribute('data-add-label') || 'Add to bag') : 'Sold out'; }
        document.querySelectorAll('[data-sticky-price]').forEach(function(el){ el.textContent = formatMoney(match.price); });
        if (match.featured_image && match.featured_image.src) swapGalleryImage(match.featured_image.src);
      } else if (atc) {
        atc.disabled = true; atc.querySelector('[data-atc-label]').textContent = 'Unavailable';
      }
    }
    resolveVariant();
  });

  // Sticky ATC reveal when main ATC scrolls out
  var stickyAtc = document.querySelector('.sticky-atc');
  var mainAtc = document.querySelector('[data-atc-anchor]');
  if (stickyAtc && mainAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      stickyAtc.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(mainAtc);
  }

  /* ---------- Recently viewed (localStorage) ---------- */
  try {
    var rvKey = 'auberlane:recently-viewed';
    var cur = document.querySelector('[data-recently-viewed-current]');
    if (cur) {
      var handle = cur.getAttribute('data-recently-viewed-current');
      var list = JSON.parse(localStorage.getItem(rvKey) || '[]').filter(function (h) { return h !== handle; });
      list.unshift(handle);
      localStorage.setItem(rvKey, JSON.stringify(list.slice(0, 8)));
    }
  } catch (e) {}
})();
